<!-- 未登录时的优惠券弹窗入口-->
<template>
  <EntryCard
    v-if="!isLogin && imgsrc"
    :imgsrc="imgsrc"
    :dataSource="dataSource"
    :page="page"
  />
</template>
<script>
  import EntryCard from './card'
  import { mapState } from 'vuex'
  import { getTip } from '@/api/activity/coupon'
  import { couponPopupShow } from '@/pages/firebase'
  import { stringToJson, isObj } from '@/utils/tool'
  import bus from '@/utils/bus'
  import { pagePopupShow } from '@/pages/marketingFirebase.js'
  import { idMlbbActBannerAB } from '@page_detail/abTest.js'

  export default {
    name: 'coupon-entry-nologin',
    components: {
      EntryCard,
    },
    props: {
      page: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        isLogin: true,
        imgsrc: '',
        dataSource: {},
        hasMounted: false,
      }
    },
    computed: {
      ...mapState([
        'userInfo',
        'gameName',
        'region',
        'source',
        'isGetapps',
        'hotfixIsFetchSuccess',
        'isApp',
      ]),
    },
    watch: {
      userInfo() {
        this.init()
      },
      hotfixIsFetchSuccess: function (val) {
        if (val && this.hasMounted) this.init()
      },
    },
    mounted() {
      this.hasMounted = true
      if (!this.hotfixIsFetchSuccess) return
      this.init()
    },
    beforeDestroy() {
      bus.$off('existCouponActivity')
    },
    methods: {
      init() {
        this.isLogin = !!(this.userInfo && this.userInfo.kicoinId)
        if (!this.isLogin) {
          this.getCouponInfo()
        }
      },
      getCouponInfo() {
        // 命中ab，则直接bus.$emit('existCouponActivity', false)
        const { isHit = false } = idMlbbActBannerAB() || {}
        if (
          isHit &&
          this.region === 'id' &&
          this.gameName === 'mobile-legends'
        ) {
          this.imgsrc = ''
          bus.$emit('existCouponActivity', false)
          return
        }
        // app内source从链接上取，默认'APP'
        let source = this.isApp
          ? this.$route.query?.source || 'APP'
          : this.source
        getTip(this.region, this.gameName, source)
          .then((res) => {
            if (res && typeof res === 'string') {
              this.imgsrc = res
              bus.$emit('existCouponActivity', false)
            }
            if (res && typeof res === 'object' && !Array.isArray(res)) {
              this.dataSource = res || {}
              const { activity } = res || {}
              const { extraInfo = '', activityId } = activity
              bus.$emit('existCouponActivity', !!activityId)
              const extra = stringToJson(extraInfo)
              if (isObj(extra)) {
                const { notLoginTipPic } = extra || {}
                this.imgsrc = notLoginTipPic
              }
            } else {
              bus.$emit('existCouponActivity', false)
            }
            if (!this.isLogin && this.imgsrc) {
              const page = this.gameName || 'home'
              if (!this.isGetapps) {
                const { activity } = res || {}
                const { activityId } = activity
                couponPopupShow({
                  act_id: activityId,
                  popup_type: 'toast',
                  page,
                })

                // 优惠券弹窗入口曝光
                pagePopupShow({
                  page,
                  act_id: activityId, // 活动编号
                  popup_type: 'toast',
                })
              }
            }
          })
          .catch(() => {
            bus.$emit('existCouponActivity', false)
          })
      },
    },
  }
</script>
